





















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {nil} from '@/common';
import {FeathersVuexFindAll} from '@/utils';
import FooterLinks from '@/components/Views/Home Page/FooterLinks.vue';
import Footer from '@/components/Views/Home Page/Footer.vue';
import PageWithSidebar from '@/components/Views/Home Page/PageWithSidebar.vue';
import {groupBy, remove} from 'lodash';
import ServiceListing from '@/components/Views/Home Page/ServiceListing.vue';
import HeaderAndCrumbs from '@/components/Views/Home Page/HeaderAndCrumbs.vue';

@Component({
    components: {
        HeaderAndCrumbs,
        ServiceListing,
        PageWithSidebar,
        Footer,
        FooterLinks,
    },
})
export default class ServicesPage extends Vue {
    @Prop({default: () => []})
    public crumbs!: any[];
    @Prop({default: ''})
    public header!: string;
    @Prop({default: () => null})
    public serviceQuery!: any;

    private services: any[] = [];
    public mounted() {
        this.getServices();
    }
    @Watch('serviceQuery')
    public onServiceQueryChanged(value: any, oldValue: any) {
        this.getServices();
    }
    private async getServices() {
        if (nil(this.serviceQuery)) { return; }
        this.services = [];
        const {Purchasable} = this.$FeathersVuex;
        const services = await FeathersVuexFindAll(Purchasable, {
            query: this.serviceQuery,
        });
        const groups = groupBy(services, 'name');
        for (const group of Object.keys(groups)) {
            let description = '';
            let image = '';
            let displayName = '';
            let displayNameSubtitle = '';
            let smallestPrice = Number.POSITIVE_INFINITY;
            let largestPrice = 0;
            for (const service of groups[group]) {
                if (nil(service.displayName, true)) {
                    displayName = service.name;
                    displayNameSubtitle = '';
                } else {
                    displayName = service.displayName;
                    displayNameSubtitle = nil(service.displayNameSubtitle, true) ? '' : service.displayNameSubtitle;
                }
                if (!nil(service.description, true) && nil(description, true)) {
                    description = service.description;
                }
                if (!nil(service.images, true) && nil(image, true)) {
                    const firstValidImage = remove(service.imageModels.map((x) => x.file))[0] as any;
                    if (!nil(firstValidImage, true)) {
                        image = firstValidImage;
                    }
                }
                if (service.price > largestPrice) { largestPrice = service.price; }
                if (service.price < smallestPrice) { smallestPrice = service.price; }
            }
            const priceRange = (smallestPrice === Number.POSITIVE_INFINITY || largestPrice === 0) ? '' : `$${smallestPrice} - $${largestPrice}`;
            this.services.push({
                name: group,
                displayName,
                displayNameSubtitle,
                description,
                imagePath: image,
                priceRange,
            });
        }
    }
}
